export default __webpack_public_path__ + "static/media/mikael_backlund2.89837720.jpg";